// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p.JSayEHijco6S4csCStXK{margin-bottom:0}`, "",{"version":3,"sources":["webpack://./../../mfe/payment-information/src/components/UpdateBillingAddressModal/updateBillingAddressModal.module.scss"],"names":[],"mappings":"AAAA,uBACE,eAAA","sourcesContent":["p.bodyText {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyText": `JSayEHijco6S4csCStXK`
};
export default ___CSS_LOADER_EXPORT___;
